import http from '@/plugins/api'
import * as types from './types'
import {
  startLoading
} from '@/plugins/loading'
import globals from '@/plugins/globals.js'
import store from '@/store'

const unknownError = 999
function getMahleApiErrorMsg(errorNo, msg) {
  var outputErr = ''
  const genericMsg = 'Check the status of the Wifi connection, try again and if the problem persists, please contact technical assistance.'
  switch (errorNo) {
    case 100: // Generic Unmanaged Error
      outputErr = `Generic unmanaged error.`
      break
    case 200: // Missing registration Data
      outputErr = `Mandatory data missing: (${msg}).`
      break
    case 204: // No Content
      outputErr = `No coin data available.`
      break
    case 300: // Login Error
      outputErr = `Wrong username.`
      break
    case 400: // Missing Astech_sn
      outputErr = `SN is not associated with any of our devices.`
      break
    case 500: // Missing registration data
      outputErr = `Missing registration data.`
      break
    case 600: // Missing Or Expired License
      outputErr = `Diagnostic Licence Expired.`
      break
    default: // Anything else
      outputErr = `Unknown error.`
      break
  }
  return `${outputErr} \r\n ${genericMsg}`
}
export default {
  setSearchTerm({ commit }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({ commit }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setSortDir({ commit }, sortDir) {
    commit(types.SET_SORT_DIR, sortDir)
  },
  setOrderBy({ commit }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  },
  setFilterBy({ commit }, filterBy) {
    commit(types.SET_FILTER_BY, filterBy)
  },
  setFilterOptions({ commit }, data) {
    commit(types.SET_FILTER_OPTIONS, data)
  },
  setNewRequest({ commit }) {
    commit('SET_NEW_REQUEST')
  },
  resetVehicle({ commit }) {
    commit('SET_VEHICLEINFO')
  },
  fetchReport({ commit }, id) {
    let language = store.getters['auth/language']

    if (language !== undefined && language !== null && language !== '') {
      if (language.toUpperCase().includes('EL') || language.toUpperCase().includes('GR')) {
        language = 'el-GR'
      } else {
        language = language + '-' + language.toUpperCase()
      }
    }
    // } else {
    //   language = 'en-US'
    // }

    // Get client domain name to determine Scan Report content.
    let domainName = window.location.hostname.toLowerCase()

    let domainNameArray = domainName.split('.')
    if (domainNameArray !== undefined && domainNameArray !== null && domainNameArray.length > 0) {
      domainName = domainNameArray[0]
    }
    console.log('Support info clientName: ', domainName)

    let url = globals.apiUrl() + '/Report/CreatePdf/?workorderId=' + id + '&cultureCode=' + language + '&domainName=' + domainName
    // cordova.InAppBrowser.open('https://docs.google.com/viewer?url=' + url, '_blank', 'location=yes,hidenavigationbuttons=yes,hideurlbar=yes')
    if (domainName.includes('repairify') || domainName.includes('uk') || domainName.includes('localhost')) {
      // For Repairify and UK Division, display Scan Report PDF as a file download.
      window.open(`${url}`, '_blank')
    } else {
      url = globals.apiUrl() + '/Report/CreatePdf/?workorderId=' + id + '%26cultureCode=' + language + '%26domainName=' + domainName
      // For other clients, display Scan Report PDF in GoogleDocsViewer in new browser window.
      window.open(`https://docs.google.com/viewer?url=${url}`, '_blank')
    }
  },
  async getScanReport({ dispatch }, data) {
    const r = await startLoading(dispatch, 'getScanReport', () =>
      http.get(`report/CreatePdf?workorderId=${data.id}&cultureCode=${data.code}`)
    )
    return r.data
  },
  async getServiceRequest({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getServiceRequest', () =>
      http.get(`ServiceRequest/ServiceRequest?id=${id}`)
    )
    commit(types.SET_REQUEST, r.data)
  },
  async getServiceRequests({ commit, dispatch }, data) {
    let query = `search=${data.search}&offset=${data.offset}&pageSize=${data.pageSize}&orderBy=${data.orderBy}&sortBy=${data.sortBy}&status=${data.status}&location=${data.location}`
    const r = await startLoading(dispatch, 'getServiceRequests', () =>
      http.get(`ServiceRequest/ServiceRequestsForList?${query}`)
    )
    commit(types.SET_REQUESTS, r.data)
    return r.data
  },
  async cloneServiceRequest({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'cloneServiceRequest', () =>
      http.get(`ServiceRequest/CloneServiceRequest?id=${data.id}&userid=${data.userid}`)
    )
    commit(types.SET_REQUEST, r.data)
  },
  async getRequestCounts({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getRequestCounts', () =>
      http.get(`ServiceRequest/GetServiceRequestCounts?id=${id}`)
    )
    commit(types.SET_REQUESTCOUNTS, r.data)
    return r.data
  },
  async decodeVin({ commit, dispatch }, vin) {
    const r = await startLoading(dispatch, 'decodeVin', () =>
      http.get(`Decoder/DecodeVinAsTech?vin=${vin}`)
    )
    commit(types.SET_VIN_SUMMARY, r.data)
  },
  async decodeVrm({ commit, dispatch }, vrm) {
    const r = await startLoading(dispatch, 'decodevrm', () =>
      http.get(`Decoder/DecodeVrm?vrm=${vrm}`)
    )
    commit(types.SET_VRM_SUMMARY, r.data)
  },
  async decodeVinUK({ commit, state, dispatch }, vin) {
    const r = await startLoading(dispatch, 'decodeVinUK', () =>
      http.get(`Decoder/DecodeVinAsTech?vin=${vin}`)
    )
    const vinSummary = r.data

    // We have a Make and Year so let's get the associated Models
    if (globals.isMahleRagEnabled()) {
      if (state.jatoMakes.length > 1 && vinSummary) {
        const makeName = vinSummary.make ? vinSummary.make.name : null
        const modelName = vinSummary.model ? vinSummary.model.name : null
        const makeYear = vinSummary.yearId
        const jatoMake = makeName
          ? state.jatoMakes.find(make => make.name.toUpperCase() === makeName.toUpperCase())
          : null

        // Populate state.jatoModels
        if (jatoMake) {
          if (makeYear && makeYear > 1985) {
            await dispatch('updateRequestRecord', {
              item: 'Year',
              value: parseInt(makeYear)
            })
          }
          await dispatch('updateRequestRecord', {
            item: 'Make',
            value: parseInt(jatoMake.value)
          })
          await dispatch('updateRequestRecord', {
            item: 'MakeName',
            value: jatoMake.name
          })
          await dispatch('getJATOVehicleModels', {
            year: vinSummary.yearId,
            make: jatoMake.name
          })
        }
        if (state.jatoModels.length > 1 && modelName) {
          const jatoModel = state.jatoModels.find(model => model.name.toUpperCase() === modelName.toUpperCase())
          if (jatoModel) {
            await dispatch('updateRequestRecord', {
              item: 'Model',
              value: parseInt(jatoModel.value)
            })
            await dispatch('updateRequestRecord', {
              item: 'ModelName',
              value: jatoModel.name
            })
          }
        }
      }
    }

    commit(types.SET_VIN_SUMMARY_UK, vinSummary)
  },
  async getVehicleYears({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'getVehicleYears', () =>
      http.get(`ServiceRequest/VehicleYears`)
    )
    commit(types.SET_YEARS, r.data)
  },
  async getVehicleMakes({ commit, dispatch }, year) {
    const r = await startLoading(dispatch, 'getVehicleMakes', () =>
      http.get(`ServiceRequest/VehicleMakes?year=${year}`)
    )
    commit(types.SET_MAKES, r.data)
  },
  async getVehicleModels({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getVehicleModels', () =>
      http.get(`ServiceRequest/VehicleModels?year=${data.year}&make=${data.make}`)
    )
    commit(types.SET_MODELS, r.data)
  },
  async resetJatoModels({ commit }) {
    commit(types.RESET_JATO_MODELS)
  },
  async getJATOVehicleYears({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'getJatoVehicleYears', () =>
      http.get(`RAGRating/JatoVehicleYears`)
    )
    commit(types.SET_JATO_YEARS, r.data)
  },
  async getJATOVehicleMakes({ commit, dispatch }, year) {
    const r = await startLoading(dispatch, 'getJATOVehicleMakes', () =>
      http.get(`RAGRating/JATOVehicleMakes?year=${year}`)
    )
    commit(types.SET_JATO_MAKES, r.data)
    commit(types.RESET_JATO_MODELS)
  },
  async getJATOVehicleModels({ commit, state, dispatch }, data) {
    if (state.request.Vehicle.Make && state.request.Vehicle.Make.Id === -1) {
      commit('SET_JATO_MODELS', [{ value: -1, name: 'Vin Mismatch' }])
    } else {
      const r = await startLoading(dispatch, 'getJATOVehicleModels', () =>
        http.get(`RAGRating/JATOVehicleModels?year=${data.year}&make=${data.make}`)
      )
      commit(types.SET_JATO_MODELS, r.data)
    }
  },
  async getVehicleSubModels({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getVehicleSubModels', () =>
      http.get(`ServiceRequest/VehicleSubModels?year=${data.year}&make=${data.make}&model=${data.model}`)
    )
    commit(types.SET_SUBMODELS, r.data)
  },
  async getVehicleEngines({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getVehicleEngines', () =>
      http.get(`ServiceRequest/VehicleEngines?year=${data.year}&make=${data.make}&model=${data.model}&submodel=${data.submodel}`)
    )
    commit(types.SET_ENGINES, r.data)
  },
  async getVehicleTransmissions({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getVehicleTransmissions', () =>
      http.get(`ServiceRequest/VehicleTransmissions?year=${data.year}&make=${data.make}&model=${data.model}`)
    )
    commit(types.SET_TRANSMISSIONS, r.data)
  },
  async getVehicleDriveTypes({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getVehicleDriveTypes', () =>
      http.get(`ServiceRequest/VehicleDriveTypes?year=${data.year}&make=${data.make}&model=${data.model}`)
    )
    commit(types.SET_DRIVETYPES, r.data)
  },
  async getScanTypes({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getScanTypes', () => {
      if (data.isMahle === false) {
        return http.get(`ServiceRequest/ScanTypes?locationId=${data.id}`)
      } else {
        return http.get(`ServiceRequest/MahleScanTypes?locationId=${data.id}`)
      }
    })
    commit(types.SET_SCANTYPES, r.data)
  },
  async getMahleTechproProducts({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getMahleTechproProducts', () => {
      return http.get(
        `ServiceRequest/MahleTechproProducts?userId=${encodeURIComponent(data.userId)}`
      )
    })

    const products = typeof r.data === 'string'
      ? JSON.parse(r.data)
      : r.data

    commit(types.SET_MAHLE_TECHPRO_PRODUCTS, products)
  },
  async getRagRatingVehicleId({ commit, dispatch }, data) {
    let make = encodeURIComponent(data.make || 'Vin Mismatch')
    let model = encodeURIComponent(data.model || 'Vin Mismatch')
    const r = await startLoading(dispatch, 'getRagRatingVehicleId', () => {
      return http.get(`RagRating/getRagRatingVehicleId?make=${make}&model=${model}&year=${data.year}`)
    })
    commit(types.SET_RAGRATINGVEHICLEID, r.data)
    return r.data
  },
  async getServiceElements({ commit, dispatch }, data) {
    if (data === null || data.scanTypeGroupId === null || data.ragRatingVehicleId === null || data.language === null || data.deviceTypeId === null) {
      const data = '[{"Id":-1,"Name":"Any","Translation":null,"RagRatingTypeId":400,"RagRatingLabel":"Green","EthernetCableRequired":false,"EVRequiresCode":false,"CustomMessage":null}]'
      commit(types.SET_SERVICEELEMENTS, data)
      return
    }
    const r = await startLoading(dispatch, 'getServiceElements', () => {
      return http.get(`RagRating/GetServiceElementsByScanTypeGroupAndVehicle?scanTypeGroupId=${data.scanTypeGroupId}&ragRatingVehicleId=${data.ragRatingVehicleId}&deviceTypeId=${data.deviceTypeId}&cultureCode=${data.language}`)
    })
    commit(types.SET_SERVICEELEMENTS, r.data)
  },
  async getServiceRequestStatusList({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'getServiceRequestStatusList', () =>
      http.get(`ServiceRequest/ServiceRequestStatusList`)
    )
    commit(types.SET_STATUSLIST, r.data)
  },
  async createServiceRequest({ commit, dispatch }, request) {
    const r = await startLoading(dispatch, 'createServiceRequest', () =>
      http.post('ServiceRequest/CreateRequest', request)
    )
    commit(types.SET_REQUESTID, r.data)
    return r.data
  },
  async createSaintGobainServiceRequest({ commit, dispatch }, request) {
    const r = await startLoading(dispatch, 'createServiceRequest', () =>
      http.post('ServiceRequest/CreateSaintGobainRequest', request)
    )
    commit(types.SET_REQUESTID, r.data)
    return r.data
  },
  updateRequestRecord({ commit }, data) {
    commit(types.UPDATE_REQUEST_RECORD, data)
  },
  async updateServiceRequest({ commit, dispatch }, request) {
    const r = await startLoading(dispatch, 'updateServiceRequest', () =>
      http.post('ServiceRequest/UpdateRequest', request)
    )
    commit(types.SET_REQUESTID, r.data)
    return r.data
  },
  async updateServiceRequestPriorities({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'updateServiceRequestPriorities', () =>
      http.post('ServiceRequest/UpdateRequestPriority', data)
    )
    commit(types.SET_REQUESTID, r.data)
  },
  async updateServiceRequestStatus({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'updateServiceRequestStatus', () =>
      http.post('ServiceRequest/UpdateRequestStatus', data)
    )
    commit(types.SET_REQUESTID, r.data)
  },
  async resendMahleReportForWorkOrderNo({ commit, dispatch }, workOrderNo) {
    commit(types.RESET_MAHLE_API_ERROR_MSG)

    var result = null
    try {
      result = await startLoading(dispatch, 'ResendMahleReportForWorkOrderNo', () =>
        http.post(`Mahle/ResendMahleReportForWorkOrderNo?workOrderNo=${workOrderNo}`)
      )

      // Api call was successful and hopefully contains the Mahle coin balance.
      console.log(`Api Call response (0): ${JSON.stringify(result)}`)
      if (result && result.status === 200 && result.data.error === 0) {
        return true
      }

      if (!result.data.status || result.data.error !== 0) {
        commit(types.SET_MAHLE_API_ERROR_MSG, getMahleApiErrorMsg(result.data.error, result.data.errorText))
      }
    } catch (e) {
      // Api call was unsuccessful.
      console.log(`Api call returned Error: ${e}`)
      commit(types.SET_MAHLE_API_ERROR_MSG, getMahleApiErrorMsg(result.data.error || unknownError, result.data.errorText || ''))
    }
    return false
  },
  async requestSupportProcessing({ commit, dispatch }, supportRequest) {
    try {
      let language = store.getters['auth/language']
      if (language !== undefined && language !== null) {
        if (language !== '') {
          language = language + '-' + language.toUpperCase()
        }
      }

      let result = await startLoading(dispatch, 'RequestSupportProcessing', () =>
        http.post(`Mahle/RequestSupportProcessing?cultureCode=${language}`, supportRequest)
      )
      return result.data
    } catch (e) {
      // Api call was unsuccessful.
      commit(types.SET_MAHLE_API_ERROR_MSG, getMahleApiErrorMsg(e.message || unknownError, e.message || ''))
      return { 'data': { 'status': false, 'error': e.id, 'errorText': e.message } }
    }
  },
  async isVinInUseAtCurrentLocation({ commit, dispatch }, data) {
    if (data === null || data.vin === null || data.locationId === null) {
      return { 'IsVinInUse': false, 'Results': [] }
    }
    const r = await startLoading(dispatch, 'IsVinInUseAtCurrentLocation', () =>
      http.get(`ServiceRequest/IsVinInUseAtCurrentLocation?vin=${data.vin}&locationId=${data.locationId}`)
    )
    return r.data
  },
  async audit({ commit, dispatch }, auditDetails) {
    if (globals.isClever() || globals.isStGobain()) {
      return
    }
    const res = await startLoading(dispatch, 'Audit', () =>
      http.post('ragrating/Audit', auditDetails)
    )
    return res.data
  },
  totalUnreadChats({ commit }, unread) {
    commit(types.UPDATE_TOTAL_UNREAD, unread)
  },
  updateUnreadChats({ commit }, channels) {
    commit(types.UPDATE_UNREAD, channels)
  },
  resetRequestUnread({ commit }, id) {
    commit(types.RESET_REQUEST_UNREAD, id)
  },
  updateRequestUnread({ commit }, unread) {
    commit(types.UPDATE_REQUEST_UNREAD, unread)
  },
  async getServiceElementsRagRating({ commit, dispatch }, data) {
    if (!data.make || !data.model || !data.year || !data.deviceTypeId) {
      console.error('Missing required parameters for RAG service elements lookup:', data)

      // Clear service elements if parameters are missing
      commit(types.SET_RAG_SERVICEELEMENTS, [])
      return []
    }

    // Set default values for optional parameters
    const orderBy = data.orderBy || 'Id'
    const sortBy = data.sortBy || 'ASC'
    const languageCode = data.languageCode || 'en'

    // URL encode the make and model to handle special characters
    const encodedMake = encodeURIComponent(data.make)
    const encodedModel = encodeURIComponent(data.model)

    try {
      // Call the new RAG Rating Controller endpoint
      const response = await startLoading(dispatch, 'getServiceElementsRagRating', () => {
        return http.get(`RAGRating/GetServiceElementsRagRating?make=${encodedMake}&model=${encodedModel}&year=${data.year}&orderBy=${orderBy}&sortBy=${sortBy}&deviceTypeId=${data.deviceTypeId}&languageCode=${languageCode}`)
      })
      commit(types.SET_RAG_SERVICEELEMENTS, response.data)
      console.log('RAG Service Elements loaded successfully:', response.data)
      return response.data
    } catch (error) {
      console.error('Error loading RAG service elements:', error)
      // Clear service elements on error - let the UI display appropriate error messages
      commit(types.SET_RAG_SERVICEELEMENTS, [])
      // Re-throw the error so the component can handle it
      throw error
    }
  },
  async getRagDeviceTypes({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'GetRagDeviceTypes', () =>
      http.get(`DeviceType/GetAllDeviceTypes`)
    )
    // Filter out deleted device types (where DeletedDate is not null)
    const activeDeviceTypes = r.data.filter(device => !device.DeletedDate && device.RAGEnabled === true)
    commit(types.SET_RAG_DEVICETYPES, activeDeviceTypes)
  },
  async getDeviceTypeImage({ dispatch }, deviceId) {
    const response = await startLoading(dispatch, 'getDeviceTypeImage', () =>
      http.get(`DeviceType/GetDeviceTypeImage/${deviceId}`, { responseType: 'blob' })
    )
    return URL.createObjectURL(response.data)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/servicerequests/actions.js